
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRotate as ObiRotateElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rotate.js';
 
 
 

 
 export const ObiRotate = createComponent({
   react: React,
   tagName: 'obi-rotate',
   elementClass: ObiRotateElement,
   events: {
     
   }
  });
 
 